<template>
  <a-config-provider
    :theme="{
      token: {
        colorPrimary: 'rgb(' + colors.primary.red + ', ' + colors.primary.green + ', ' + colors.primary.blue + ')',
        colorLink: store.user && userPreferences.darkMode ? '#fff' : '#000',
        colorLinkHover: 'rgb(' + colors.primary.red + ', ' + colors.primary.green + ', ' + colors.primary.blue + ')',
      },
      algorithm: store.user && userPreferences.darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
    }"
  >
    <div
      v-if="appLoading"
      class="page-loading selection:bg-primary/75"
    >
      <div class="loader">
        <svg
          class="circular"
          viewBox="25 25 50 50"
        >
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="2"
            stroke-miterlimit="10"
          />
        </svg>
      </div>
    </div>
    <component
      :is="route.meta.layout || 'div'"
      v-else
      data-attr="layout-wrapper"
    >
      <router-view class="bg-white selection:bg-primary/75" />
    </component>
    <workspace-switcher-popup />
  </a-config-provider>
</template>

<script setup lang="ts">
import { useStore } from './api/index.ts';
import { theme } from 'ant-design-vue';
import { storeToRefs } from 'pinia';
import { onBeforeUnmount, onMounted } from 'vue';
import { setHTMLDarkMode } from './assets/js/helpers/DarkThemeHelper.ts';
import { useRoute } from 'vue-router';
import { consoleWelcome } from './assets/js/helpers/consoleDebug.ts';
import { getApp } from 'firebase/app';
import WorkspaceSwitcherPopup from './components/Modals/WorkspaceSwitcherPopup.vue';
import { cleanupImageCache, IMAGE_CACHE_TTL_MS } from './assets/js/imageStore';

const store = useStore();
const route = useRoute();

// We need to watch these so call storeToRefs to make them reactive
const { appLoading, userPreferences, colors } = storeToRefs(store);

let unsubscribe: () => void;
let imageCacheSweepTimer: number | undefined;

onMounted(() => {
  // Always reset the dbid and build to the environment variables
  store.dbid = import.meta.env.VITE_FIREBASE_DBID;
  store.build = import.meta.env.VITE_BUILD;
  // Call authAction
  store.initializeFirebase().then(() => {
    store.authState();
    imageCacheSweepTimer = window.setInterval(() => {
      cleanupImageCache();
    }, IMAGE_CACHE_TTL_MS);
  });

  if (store.userPreferences.darkMode && store.user) {
    setHTMLDarkMode(true);
  }

  consoleWelcome();
  unsubscribe = store.watchReleaseBuild(getApp(store.firebaseApp));
});

onBeforeUnmount(() => {
  if (imageCacheSweepTimer !== undefined) {
    clearInterval(imageCacheSweepTimer);
  }
  if (unsubscribe) {
    unsubscribe();
  }
});
</script>
